import React from 'react';
import * as styles from './singleVideo.module.scss';
import { SanityContentVideo } from '../../../../../graphql-types';
import { VideoPlayer } from '../../../../components/2.0version/videoPlayer/VideoPlayer';
import { usePageContext } from '../../../../hooks/contexts/usePageContext';

export interface ISingleVideoProps {
  data: SanityContentVideo;
}

export const SingleVideo = ({ data }: ISingleVideoProps) => {
  const { lang } = usePageContext();
  const { url } = data;

  const playerWidth = '100%';
  const subtitle = data?._rawCaption?.[lang];
  return (
    <div className={styles.wrapper}>
      {url && <VideoPlayer video={url} width={playerWidth} controls={false} />}
    </div>
  );
};
